
import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator'
@Component
export default class Backer extends Vue {
    @Prop({ type: Boolean, default: false })
    isEnable
}
